import { render } from "./StepForward.vue?vue&type=template&id=34df9878"
import script from "./StepForward.vue?vue&type=script&lang=js"
export * from "./StepForward.vue?vue&type=script&lang=js"
script.render = render

export default script